import { emptyObj } from 'util/objects'

const selectByIdIncArchived = state => state.agents.byId || emptyObj

export default selectByIdIncArchived
